export enum Reward {
  IS_GOOD_RELATIVE_VALUE = 'IsGoodRelativeValue',
  IS_TRADING_BELOW_ANALYST_PRICE_TARGETS = 'IsTradingBelowAnalystPriceTargets',
}
